import React, { useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { dashboardPath } from '../dashboard/dashboardUrl';
import { useAuth } from './AuthContext';
import { markLoggedInBefore } from './priorLoginCookie';

const LoginSuccessRedirect = () => {
  const { authChecked } = useAuth();

  useEffect(() => {
    markLoggedInBefore();
  }, []);

  if (!authChecked) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  const returnTo = sessionStorage.getItem('authReturnTo');
  if (returnTo) {
    sessionStorage.removeItem('authReturnTo');
    return <Navigate to={returnTo} replace />;
  }
  return <Navigate to={dashboardPath()} replace />;
};

export default LoginSuccessRedirect;
